import { ParadiseDetailsSection } from "src/components/Paradise/ParadiseDetailsLayout"
import { ParadiseDevicesTable } from "src/components/Paradise/ParadiseDevicesTable"
import { useParadiseDevicesFilter } from "src/components/Paradise/useParadiseDevicesFilter"
import { useFetchDevices } from "src/data/devices/queries/deviceQueries"
import { IDevicesFilter } from "src/data/devices/types/deviceTypes"
import { useSortParam } from "src/ui/GridTable/useTableColumns/useSortParam"

const LIMIT = 50

const ALLOWED_SORT_KEYS = [
  "battery",
  "home_name",
  "description",
] satisfies IDevicesFilter["sort"][]

type AllowedSortKey = (typeof ALLOWED_SORT_KEYS)[number]

function parseSortKey(key: string | undefined): AllowedSortKey {
  if (ALLOWED_SORT_KEYS.includes(key as AllowedSortKey)) {
    return key as AllowedSortKey
  }
  return "description"
}

export function ParadiseOrganizationDevices({ orgId }: { orgId: string }) {
  const { filter, setFilter, offset, setOffset, sortedFilter } =
    useParadiseDevicesFilter()
  const { sortValue, setSortValue } = useSortParam()

  const fetchedDevices = useFetchDevices({
    orgId,
    filter: {
      limit: LIMIT,
      offset,
      ids: filter.devices_id ? [filter.devices_id] : undefined,
      description: filter.devices_description || undefined,
      active: !filter.devices_include_inactive ? true : undefined,
      hardware_version: filter.devices_hardwareVersion ?? undefined,
      offline: filter.devices_offline ?? undefined,
      sort: parseSortKey(sortValue?.id),
    },
    options: {
      keepPreviousData: true,
    },
  })

  const devices = fetchedDevices.data?.devices ?? []

  return (
    <div>
      <ParadiseDetailsSection title="Devices" />
      <ParadiseDevicesTable
        devices={devices}
        offset={offset}
        limit={LIMIT}
        setOffset={setOffset}
        filter={filter}
        setFilter={setFilter}
        sortedFilters={sortedFilter}
        sort={sortValue}
        setSort={setSortValue}
        totalCount={fetchedDevices.data?.paging?.total_count}
        isLoading={fetchedDevices.isPreviousData}
        error={{
          hasError: fetchedDevices.isError,
          title: fetchedDevices.error?.message,
        }}
        disableColumnHiding
        disabledFilters={["owner", "tags", "device_mac", "firmware"]}
      />
    </div>
  )
}
